export const getYmapsConstructor = async () => {
  if (window.createMap) return window.createMap;
  try {
    window.createMap = (await import("../ymaps3/constructor.js")).createMap;
    return window.createMap;
  } catch (err) {
    console.error("Ошибка загрузки createMap:", err);
  }
};
